<div class="cet-instruction-steps-container" *ngIf="instruction">
  <div class="instruction-item">
    <div class="text">
      <span class="numeric" *ngIf="!completed">
        {{ index }}
      </span>
      <span class="check" *ngIf="completed">
        <img src="assets/images/check.svg" alt="completed" />
      </span>
      <span>{{ instruction }}</span>
    </div>

    <div class="icon" (click)="chooseFile()" *ngIf="!completed" [style.pointer-events]="loading? 'none' : 'auto'">
      <img src="assets/images/uploadBtn.svg" *ngIf="!loading" alt="icon" />
      <img
        src="assets/images/rolling.webp"
        style="max-width: 25px"
        *ngIf="loading"
        alt="icon"
      />
    </div>
    <div class="delete icon" (click)="deleteFile()" *ngIf="completed">
      <i class="bi bi-trash3-fill" *ngIf="!loading"></i>
      <img
        src="assets/images/rolling.webp"
        style="max-width: 25px"
        *ngIf="loading"
        alt="icon"
      />
    </div>
  </div>
  <div class="errorMessage" *ngIf="errorMessage">{{errorMessage}}</div>
  <div class="errorMessage" *ngIf="maxSizeExceeded">
    File Size ({{ ((fileSize + 25) / 1024).toFixed(2) }}MB) exceeded the max
    size (1MB)
  </div>
  <div
    class="card shadow rounded"
    style="width: 100%; color: #696f83"
    *ngIf="uploading && uploadProgress != 100"
  >
    <div
      class="upload-info card-body pt-5 pb-3 d-flex justify-content-between align-items-center"
    >
      <span class="cancel-btn" (click)="cancelUpload()">
        <i class="bi bi-x-circle"></i>
      </span>
      <div class="row col-12" style="padding-inline-end: 15px">
        <div class="col-2 d-flex align-items-center justify-content-center">
          <img src="assets/images/file.svg" alt="uploading-file" />
        </div>
        <div class="col-10 d-flex flex-column">
          <p
            style="text-align: start; font-size: 12px"
            class="d-flex justify-content-between"
          >
            <strong>{{ fileName }}</strong>
            <strong>{{ fileSize }}KB</strong>
          </p>
          <div class="progress">
            <div
              class="progress-bar"
              [style.width]="uploadProgress + '%'"
            ></div>
          </div>
          <div
            class="progress-info d-flex align-items-center justify-content-between my-2"
          >
            <small>{{ uploadProgress }}% done</small>
            <small>{{ speed }} KB/sec</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<input
  type="file"
  accept=".pdf, .png, .jpg, .jpeg;capture=camera"
  name="salary"
  id="fileUploader{{ rand }}"
  (change)="startUpload($event)"
/>
